module.exports = __webpack_public_path__ + "img/undo.42ff9f41.svg";